import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { AuthCard } from '@/components/auth/auth-card';
import { AuthField } from '@/components/auth/auth-field';
import { AuthForm } from '@/components/auth/auth-form';
import { requestRecoveryFn } from '@/server/functions/auth';

export const Route = createFileRoute('/_auth/recover')({
    component: RecoverPage,
});

const recoverSchema = z.object({
    email: z.email('נא להזין כתובת אימייל תקינה'),
});

function RecoverPage() {
    const [sent, setSent] = useState(false);
    const form = useForm({
        resolver: zodResolver(recoverSchema),
        defaultValues: {
            email: '',
        },
    });

    const recoverMutation = useMutation({
        mutationFn: async (data: z.infer<typeof recoverSchema>) => {
            await requestRecoveryFn({ data: { email: data.email } });
        },
        onSuccess: () => {
            setSent(true);
        },
        onError: (error: Error) => {
            form.setError('root', { message: error.message });
        },
    });

    return (
        <AuthCard
            title="איפוס סיסמה"
            description="נשלח אליכם קישור לאיפוס הסיסמה לכתובת המייל הרשומה בחשבון."
            footer={
                <Link to="/sign-in" className="!no-underline hover:underline">
                    חזרה להתחברות
                </Link>
            }
        >
            {sent ? (
                <div className="space-y-3 text-sm leading-relaxed text-white/55">
                    <p>
                        אם הכתובת קיימת אצלנו, נשלח אליה מייל עם קישור לאיפוס
                        הסיסמה. הקישור בתוקף לשעה אחת.
                    </p>
                    <p className="text-white/55">
                        לא רואים את המייל? בדקו בתיקיית הספאם או נסו שוב.
                    </p>
                </div>
            ) : (
                <AuthForm
                    schema={recoverSchema}
                    defaultValues={{ email: '' }}
                    onSubmit={(data) => recoverMutation.mutate(data)}
                    submitText="שליחת קישור איפוס"
                    isLoading={recoverMutation.isPending}
                    form={form}
                >
                    {(f) => (
                        <AuthField
                            control={f.control}
                            name="email"
                            label="אימייל"
                            placeholder="editor@ashkelon.news"
                            type="email"
                        />
                    )}
                </AuthForm>
            )}
        </AuthCard>
    );
}
